import React, { useState } from 'react';
import { Container, makeStyles } from '@material-ui/core';
import Page from '@components/template/Page';
import PageHeader from '@components/organisms/PageHeader/index';
import MoneyIcon from '@material-ui/icons/AttachMoneyTwoTone';
import { DatePicker } from '@material-ui/pickers';
import ProfitTable from '@pages/profits/body/ProfitTable';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const ProfitView = () => {
  const classes = useStyles();
  const [date, setDate] = useState(new Date());

  return (
    <Page className={classes.root} title="Admin">
      <Container maxWidth="lg">
        <PageHeader
          title="수익현황"
          subTitle="편집 페이지"
          icon={<MoneyIcon fontSize="large" />}
        />

        <DatePicker
          autoOk
          orientation="landscape"
          variant="dialog"
          openTo="date"
          labelFunc={date => date.format('YYYY/MM/DD')}
          value={date}
          onChange={setDate}
        />

        <ProfitTable date={date} />
      </Container>
    </Page>
  );
};

export default ProfitView;
